import { render, staticRenderFns } from "./EditAgentModal.vue?vue&type=template&id=354d81b8&"
import script from "./EditAgentModal.vue?vue&type=script&lang=js&"
export * from "./EditAgentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports